import React from 'react';
import MenuItem from './menu-item';

export default class Menu extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeItem: props.defaultItem
        }
    }

    setItem(id) {
        let cb = (typeof this.props.onChange === 'function') ? this.props.onChange : () => {};

        this.setState({
            activeItem: id
        }, () => cb(id));
    }

    shouldRenderItem() {
        return true;
    }

    renderMenuItems(items) {
        return items.map((item, i) => {
            if (!this.shouldRenderItem(item, i)) {
                return null;
            }
            return (
                <MenuItem key={i} href={item.path} active={item.path === this.props.appState}>
                    {item.text}
                </MenuItem>
            )
        })
    }

    renderChildren() {
        return React.Children.map(this.props.children, child => {
            if (child.type === MenuItem) {
                return React.cloneElement(child, {
                    active: child.props.itemId === this.state.activeItem,
                    onClick: (e, item) => this.setItem(item)
                });
            }
        })
    }

    render() {
        let items = (this.props.items) ? this.renderMenuItems(this.props.items) : this.renderChildren();

        return (
            <div { ...this.props } className={['component-menu', this.props.className].join(' ')}>
                <div className="menu-list">
                    { items }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web-app/components/menu.jsx